document.addEventListener('click', function (e) {
  var resetBtn = e.target.closest('.reset__button.color-secondary.field__button');
  if (!resetBtn) return;

  document.querySelectorAll('.theme--error-message.special--medium').forEach(function (el) {
    el.textContent = '';      // clear the text
    el.classList.add('hidden'); // optional: hide it too, if your theme has a .hidden class
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const predictiveSearch = document.querySelector('.predictive-search');

  if (!predictiveSearch) return;

  // When Clear / Reset is clicked
  document.addEventListener('click', (event) => {
    const resetButton = event.target.closest('.reset__button');

    if (!resetButton) return;

    predictiveSearch.classList.add('hide-search-terms');
  });

  // Find the search input
  const searchInput = document.querySelector(
    'input[type="search"], input[name="q"]'
  );

  if (!searchInput) return;

  // When user starts typing again
  searchInput.addEventListener('input', () => {
    if (searchInput.value.trim().length > 0) {
      predictiveSearch.classList.remove('hide-search-terms');
    }
  });
});
